import React from 'react';
class Widget extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-sm-12 widget" },
                React.createElement("div", { className: "row" }, this.props.children))));
    }
}
export default Widget;
